import type { InventoryUnit } from "./types";

export function inventoryAppearance(unit: InventoryUnit) {
  const isStandardHdx = unit.inventory_type === "TOTE" && unit.container_type === "HDX Tough Tote";
  const dimensions = !isStandardHdx && [unit.length, unit.width, unit.height].some(Boolean)
    ? `${unit.length || "—"} × ${unit.width || "—"} × ${unit.height || "—"} in`
    : "";
  const color = unit.container_color
    ? `${unit.container_color}${unit.lid_color ? ` / ${unit.lid_color} lid` : ""}`
    : unit.lid_color ? `${unit.lid_color} lid` : "";
  return [dimensions, color].filter(Boolean).join(" · ");
}
